/**
 * Confirmation shown when a decider withdraws somebody else's request. Withdrawal is
 * final — there is no restore — so the requester has to submit the fee again.
 */
export function withdrawOthersConfirm(requestedByName: string): string {
  return (
    `Wycofać prośbę złożoną przez: ${requestedByName}?\n\n` +
    "Wycofanej prośby nie da się przywrócić — jeśli opłata jest potrzebna, " +
    "wnioskujący musi złożyć ją ponownie."
  );
}
